






























































































import LazyHydrate from 'vue-lazy-hydration';
import SfSelect from '/storefrontUI/components/components/molecules/SfSelect/SfSelect.vue';
import SfHeading from '/storefrontUI/components/components/atoms/SfHeading/SfHeading.vue';
import HTMLContent from '~/components/HTMLContent.vue';
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  ssrRef,
  useFetch, useRoute,
} from '@nuxtjs/composition-api';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import { usePageStore } from '~/stores/page';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import CategoryPagination from '~/modules/catalog/category/components/pagination/CategoryPagination.vue';
import {
  Params,
  useContent,
  useFacet,
  useUiHelpers,
  useUiState,
  useConfig,
  useProduct,
} from '~/composables';

import { useAddToCart } from '~/helpers/cart/addToCart';
import { useWishlist } from '~/modules/wishlist/composables/useWishlist';
import { usePrice } from '~/modules/catalog/pricing/usePrice';
import facetGetters from '~/modules/catalog/category/getters/facetGetters';

import { CmsPage, Products } from '~/modules/GraphQL/types';

import CategoryNavbar from '~/modules/catalog/category/components/navbar/CategoryNavbar.vue';
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';

import type { ProductInterface, Aggregation } from '~/modules/GraphQL/types';
import type { SortingModel } from '~/modules/catalog/category/composables/useFacet/sortingOptions';
import type { Pagination } from '~/composables/types';
import type { Product } from '~/modules/catalog/product/types';
import {getMetaInfo} from "~/helpers/getMetaInfo";

export default defineComponent({
  name: 'CategoryPage',
  components: {
    CategoryPagination,
    CategoryEmptyResults: () => import('~/modules/catalog/category/components/CategoryEmptyResults.vue'),
    CategoryFilters: () => import('~/modules/catalog/category/components/filters/BrandFilters.vue'),
    CmsContent: () => import('~/modules/catalog/category/components/cms/CmsContent.vue'),
    CategoryProductGrid: () => import('~/modules/catalog/category/components/views/CategoryProductGrid.vue'),
    CategoryProductList: () => import('~/modules/catalog/category/components/views/CategoryProductList.vue'),
    CategoryNavbar,
    CategoryBreadcrumbs,
    SfSelect,
    LazyHydrate,
    SfHeading,
    SkeletonLoader,
    HTMLContent,
  },
  transition: 'fade',
  setup() {
    const route = useRoute();
    const { routeData } = usePageStore();
    const { addTags } = useCache();
    const uiHelpers = useUiHelpers();
    const isShowProducts = ref(true);
    const products = ssrRef<ProductInterface[]>([]);
    const aggregations = ssrRef<Aggregation[]>([]);
    const sortBy = ref<SortingModel>({ selected: '', options: [] });
    const pagination = ref<Pagination>({});
    const { loadPage } = useContent();
    const page = ref<CmsPage | null>(null);
    const { config } = useConfig();
    const { getProductList } = useProduct();

    const productContainerElement = ref<HTMLElement | null>(null);

    const url = route.value.fullPath;

    const logoSrc = computed(() => {
      const baseMediaUrl = config.value.base_media_url;
      const logo = config.value.header_logo_src;

      return baseMediaUrl && logo ? `${baseMediaUrl}logo/${logo}` : '';
    });

    const {
      toggleFilterSidebar,
      changeToCategoryListView,
      changeToCategoryGridView,
      isCategoryGridView,
      isFilterSidebarOpen,
    } = useUiState();
    const {
      load: loadWishlist,
      addItem: addItemToWishlistBase,
      isInWishlist,
      removeItem: removeItemFromWishlist,
    } = useWishlist();
    const { result, search } = useFacet();
    const { addItemToCart } = useAddToCart();

    const categoryMeta = ref(null);

    const addItemToWishlist = async (product: Product) => {
      await (isInWishlist({ product })
        ? removeItemFromWishlist({ product })
        : addItemToWishlistBase({ product }));
    };

    const { fetch } = useFetch(async () => {

      const filters = uiHelpers.getFacetsFromURL();
      let term = url.split("/");
      let term2 = term[term.length - 1];
      let term3 = term2.split("?");
      let term4 = term3[0].replace('-', ' ');
      let term5 = term4[0].toUpperCase()+term4.slice(1);
      if (term5 == 'Elhannh') {
        term5 = 'Elhann.h'
      }
      //console.log(term4[0].toUpperCase()+term4.slice(1));
      const productList : Products = await getProductList({
        pageSize: 100,
        filter: {
          /*category_uid : {
            eq: "NQ=="
          },*/
          name: {
            match: term5
          }
        }
      }) as Products;

      const brands = [];
      if(productList.aggregations.length > 0){
        for(var key in productList.aggregations) {
          if (productList.aggregations.hasOwnProperty(key)) {
            if(productList.aggregations[key].attribute_code == 'mgs_brand'){
              brands.push(productList.aggregations[key].options);
            }
          }
        }
      }

      const levenshteinDistance = (s, t) => {
        if (!s.length) return t.length;
        if (!t.length) return s.length;
        const arr = [];
        for (let i = 0; i <= t.length; i++) {
          arr[i] = [i];
          for (let j = 1; j <= s.length; j++) {
            arr[i][j] =
              i === 0
                ? j
                : Math.min(
                  arr[i - 1][j] + 1,
                  arr[i][j - 1] + 1,
                  arr[i - 1][j - 1] + (s[j - 1] === t[i - 1] ? 0 : 1)
                );
          }
        }
        return arr[t.length][s.length];
      };

      let brand = [];
      let score = 99999999;
      if(brands.length > 0){
        for(var key in brands[0]) {
          if (brands[0].hasOwnProperty(key)) {
            //let distance = levenshteinDistance(brands[0][key].label, term4[0].toUpperCase()+term4.slice(1));
            let distance = levenshteinDistance(term4[0].toUpperCase()+term4.slice(1), brands[0][key].label);
            //console.log(brands[0][key].label+' '+distance);
            if(distance < score ){
              score = distance;
              brand.push(brands[0][key].value);
              //console.log(brands[0][key].label+' '+score);
            }

            //if(!brands[0][key].label.indexOf('Colmar')) {
            //  brand.push(brands[0][key].value);
            //}
          }
        }
      }

      page.value = await loadPage({ identifier: routeData.identifier });
      const cat = ["NQ==", "Ng=="];

      if(brand.length == 0){
        brand.push(term4[0].toUpperCase()+term4.slice(1));
      }
      if(filters.filters.mgs_brand !== undefined){
        filters.filters.mgs_brand.push(brand[brand.length-1]);
      }
      else{
        filters.filters.mgs_brand = brand[brand.length-1];
      }



      await Promise.all([
        search({ ...filters, category_uid: cat }),
      ]);

      products.value = facetGetters.getProducts(result.value) ?? [];
      aggregations.value = result.value.data.aggregations ?? [];
      sortBy.value = facetGetters.getSortOptions(result.value);
      pagination.value = facetGetters.getPagination(result.value);

      if (products.value.length > 0) {
        const mgs_brand = [];
        if (aggregations.value.length > 0) {
          for(var key in aggregations.value) {
            if (aggregations.value.hasOwnProperty(key)) {
              if(aggregations.value[key].attribute_code == 'mgs_brand'){
                mgs_brand.push(aggregations.value[key].options);
              }
            }
          }
        }
        products.value = products.value.map((product) => {
          const brand = mgs_brand[0].find(item => item.value == product.mgs_brand)?.label;
          if (brand) {
            return {
              ...product,
              brand: brand,
            };
          }

          return { ...product };
        });
      }

      const tags = [{ prefix: CacheTagPrefix.View, value: routeData.identifier }];
      const productTags = products.value.map((product) => ({
        prefix: CacheTagPrefix.Product,
        value: product.uid,
      }));

      addTags([...tags, ...productTags]);
    });

    const isPriceLoaded = ref(false);

    onMounted(async () => {
      loadWishlist();
      const { getPricesBySku } = usePrice();
      if (products.value.length > 0) {
        const skus = products.value.map((item) => item.sku);
        const priceData = await getPricesBySku(skus, pagination.value.itemsPerPage);
        products.value = products.value.map((product) => {
          const priceRange = priceData.items.find((item) => item.sku === product.sku)?.price_range;
          if (priceRange) {
            return {
              ...product,
              price_range: priceRange,
            };
          }

          return { ...product };
        });
      }

      isPriceLoaded.value = true;
    });

    const goToPage = (page: number) => {
      uiHelpers.changePage(page, false);
      fetch();
    };

    const doChangeItemsPerPage = (itemsPerPage: number) => {
      uiHelpers.changeItemsPerPage(itemsPerPage, false);
      goToPage(0);
    };

    const onReloadProducts = () => {
      goToPage(0);
      productContainerElement.value.scrollIntoView();
    };

    return {
      isPriceLoaded,
      ...uiHelpers,
      toggleFilterSidebar,
      isCategoryGridView,
      changeToCategoryListView,
      changeToCategoryGridView,
      isFilterSidebarOpen,
      addItemToCart,
      addItemToWishlist,
      pagination,
      products,
      sortBy,
      isShowProducts,
      routeData,
      doChangeItemsPerPage,
      productContainerElement,
      onReloadProducts,
      goToPage,
      page,
      logoSrc,
      url,
      getMetaInfo,
    };
  },
  head() {
    return getMetaInfo(this.page, false, this.logoSrc, 'https://www.needstore.it' + this.url);
  },
});
